import React, { useState } from "react";
import styled from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import {
  BackwardArrow,
  ContactBg,
  ContactMan,
  ForwardArrow,
} from "../../styled/AllImages";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  SpanStyled,
} from "../../styled/Elements";
import { useTranslation } from "react-i18next";
import ContactModal from "../../auth/Modal/ContactModal";

const Contact = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  return (
    <Container
      fluid="md"
      className="container-fluid common-space faqsFluid py-5"
      id="contact"
    >
      <ContactWrapper>
        <Row className="contact-content align-items-center justify-content-between">
          <Col lg={9}>
            <SpanStyled
              size="40px"
              color="var(--white)"
              weight="light"
              className="contact-heading"
            >
              {t("keep_connected_to_progress")}
            </SpanStyled>
          </Col>
          <Col lg={3}>
            <Box className="contact-btn d-flex justify-content-center">
              <ButtonStyled
                iconAfter={language === "en" ? BackwardArrow : ForwardArrow}
                size="24px"
                bg={"var(--bgNew)"}
                color={"var(--themeColorSecondary)"}
                label={t("contact_us")}
                className="mt-3 mt-lg-0 py-4 px-4"
                onClick={() => setShowModal(true)}
              />
            </Box>
          </Col>
        </Row>
        {/* <ImageSection>
          <img src={ContactMan} alt="Man" />
        </ImageSection> */}
      </ContactWrapper>
      <ContactModal show={showModal} onHide={() => setShowModal(false)} />
    </Container>
  );
};

export default Contact;

const ContactWrapper = styled.div`
  background: url(${ContactBg}) no-repeat center;
  border-radius: 10px;

  height: 140px;
  padding: 2rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  /* overflow: hidden; */
  position: relative;
  color: #fff;
  margin: 1rem 0;

  .contact-content {
    z-index: 2;

    .contact-heading {
      line-height: 1;
    }
  }

  @media (max-width: 992px) {
    height: auto;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (max-width: 576px) {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    text-align: center;
    .contact-heading {
      font-size: 30px;
    }
    .contact-btn {
      justify-content: center !important;
    }
  }
`;

const ImageSection = styled.div`
  position: absolute;
  right: 100px;
  bottom: 0;
  max-width: 367px;

  body.rtl & {
    right: unset;
    left: 100px;
    img {
      transform: scaleX(-1);
    }
  }

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 1200px) {
    max-width: 300px;
    right: 40px;
  }
  @media (max-width: 992px) {
    display: none;
  }
`;
